 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~custom-story-template-chunk~header_1~header_2~header_3~header_4~home~list~listicle-story-tem~060546a3","1":"vendors~custom-story-template-chunk~header_1~header_2~header_3~header_4~listicle-story-template-chun~50de26b7","2":"vendors~custom-story-template-chunk~glide~home~list~listicle-story-template-chunk~live-blog-story-te~325c31a3","3":"header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer-header_~5c4876bb","4":"vendors~custom-story-template-chunk~home~list~listicle-story-template-chunk~live-blog-story-template~ccc0fbb2","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","7":"vendors~firebase-app~firebase-messaging","8":"vendors~home~list","11":"SSOWrapperBase","12":"SidebarTemplate","14":"custom-story-template-chunk","15":"firebase-app","17":"footer_1","18":"footer_2","19":"footer_3","20":"glide","21":"header_1","22":"header_2","23":"header_3","24":"header_4","25":"home","26":"list","27":"listicle-story-template-chunk","28":"live-blog-story-template-chunk","29":"metypeFeedWidget","30":"other-story-template-chunk","31":"photo-story-template-chunk","33":"qtc-parsecsv","34":"secret-mode","36":"single-layer-header_1","37":"single-layer-header_2","38":"single-layer-header_3","39":"single-layer-header_4","40":"single-layer-header_5","41":"story","42":"subscription","43":"text-story-template-chunk","44":"vendors~firebase-messaging","45":"vendors~qtc-react-youtube","46":"vendors~secret-mode","47":"vendors~story","48":"video-story-template-chunk"}[chunkId]||chunkId) + "-" + "e873e3d42452e7790cbd" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"6":1,"8":1,"9":1,"11":1,"12":1,"14":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"30":1,"31":1,"34":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"47":1,"48":1,"50":1,"51":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~custom-story-template-chunk~header_1~header_2~header_3~header_4~home~list~listicle-story-tem~060546a3","1":"vendors~custom-story-template-chunk~header_1~header_2~header_3~header_4~listicle-story-template-chun~50de26b7","2":"vendors~custom-story-template-chunk~glide~home~list~listicle-story-template-chunk~live-blog-story-te~325c31a3","3":"header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer-header_~5c4876bb","4":"vendors~custom-story-template-chunk~home~list~listicle-story-template-chunk~live-blog-story-template~ccc0fbb2","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","7":"vendors~firebase-app~firebase-messaging","8":"vendors~home~list","11":"SSOWrapperBase","12":"SidebarTemplate","14":"custom-story-template-chunk","15":"firebase-app","17":"footer_1","18":"footer_2","19":"footer_3","20":"glide","21":"header_1","22":"header_2","23":"header_3","24":"header_4","25":"home","26":"list","27":"listicle-story-template-chunk","28":"live-blog-story-template-chunk","29":"metypeFeedWidget","30":"other-story-template-chunk","31":"photo-story-template-chunk","33":"qtc-parsecsv","34":"secret-mode","36":"single-layer-header_1","37":"single-layer-header_2","38":"single-layer-header_3","39":"single-layer-header_4","40":"single-layer-header_5","41":"story","42":"subscription","43":"text-story-template-chunk","44":"vendors~firebase-messaging","45":"vendors~qtc-react-youtube","46":"vendors~secret-mode","47":"vendors~story","48":"video-story-template-chunk"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"4ddf01ca480a95132732","4":"deb18478f447e4fb46b5","5":"31d6cfe0d16ae931b73c","6":"99ea8bc551d437ab7d4f","7":"31d6cfe0d16ae931b73c","8":"fd1f7b085319230ca3a7","9":"5dc4add22f2b41d07914","10":"31d6cfe0d16ae931b73c","11":"b7cc75a71960e17686fc","12":"18b733ced811705b4edf","14":"df4f17ed55ab98716ee1","15":"31d6cfe0d16ae931b73c","17":"329c7cd14a52ad39f165","18":"0ec49345a69d0c72541d","19":"cc8c61a031a02a05667b","20":"af6f2cb1648cb603f8a6","21":"799420c0f3d30916cd6f","22":"b6aa0e3d22cb4dd53cfa","23":"9b1a365a83c239e07fd0","24":"4616eee66621e4e18868","25":"9b841d4f3f26eb50b05b","26":"6f9bb0518cc414a5a031","27":"df4f17ed55ab98716ee1","28":"df4f17ed55ab98716ee1","29":"31d6cfe0d16ae931b73c","30":"df4f17ed55ab98716ee1","31":"df4f17ed55ab98716ee1","33":"31d6cfe0d16ae931b73c","34":"5c8f7031f724c077a806","36":"5b3bc1536fd1bd294e5d","37":"f53a7ae049399f9b0812","38":"a713fafda248261e1006","39":"c5e41dbb0ec0c7da3360","40":"e73213fcc7e7ba4e35dd","41":"e2e96e98a17acf8cacd9","42":"aadc91e2ad9e04113a1d","43":"df4f17ed55ab98716ee1","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"2adfa6f01ef6f2179b8f","48":"df4f17ed55ab98716ee1","49":"31d6cfe0d16ae931b73c","50":"7b2c3067e4c007a0e873","51":"5527071b0981c02ee2ae","52":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 239);
